// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"9ec2fe39","427":"c0d9edee","607":"1fcf2887","898":"e6dd6f0d","963":"7fa86155"}[chunkId] + ".chunk.js";
};